import { render, staticRenderFns } from "@/style-guide/partials/icon/icon.pug?vue&type=template&id=6418147b&scoped=true&lang=pug&external"
import script from "./icon.vue?vue&type=script&lang=ts"
export * from "./icon.vue?vue&type=script&lang=ts"
import style0 from "./icon.vue?vue&type=style&index=0&id=6418147b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6418147b",
  null
  
)

export default component.exports